// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"392":"india-cities","902":"heic"}[chunkId] + "." + {"392":"ae11e8df","902":"0d91213e"}[chunkId] + ".chunk.js";
};